import { TriangleAlert } from 'lucide-react'
import { CellStatusBadge } from '@/shared/components/data-table'

type CellNegotiationStateProps = {
  name?: string | null
  color?: string | null
  overdue?: boolean
  rejected?: boolean
}

export function CellNegotiationState({
  name,
  color,
  overdue = false,
  rejected = false
}: CellNegotiationStateProps) {
  const attentionLabels = [overdue ? 'Vencida' : null, rejected ? 'Rechazada' : null].filter(
    (label): label is string => Boolean(label)
  )
  const attentionLabel = attentionLabels.join(' · ')

  return (
    <div className="flex h-8 min-w-max items-center gap-1.5 whitespace-nowrap">
      <CellStatusBadge
        label={name ?? 'Sin estado'}
        color={color}
        className="shrink-0 whitespace-nowrap"
      />

      {attentionLabel ? (
        <span className="inline-flex h-6 shrink-0 items-center gap-1 rounded-full border border-destructive/20 bg-destructive/10 px-2 text-[11px] font-medium text-destructive">
          <TriangleAlert aria-hidden="true" className="h-3 w-3" />
          {attentionLabel}
        </span>
      ) : null}
    </div>
  )
}
